import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "../pages/login/LoginPage";


export const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
    </Routes>
  );
};
